import CheckNewOrders from "../symbols/checkNewOrdersFailed";
import { HttpRequestPost } from "../../service";

const checkNewOrdersFailedAction = () => ({
  type: CheckNewOrders.CHECK_NEW_ORDERS_FAILED,
});
const checkNewOrdersFailedSuccessAction = (data: any) => ({
  type: CheckNewOrders.CHECK_NEW_ORDERS_FAILED_SUCCESS,
  payload: data,
});
const checkNewOrdersFailedFailureAction = (data: any) => ({
  type: CheckNewOrders.CHECK_NEW_ORDERS_FAILED_FAILURE,
  payload: data,
});
const clearCheckNewOrdersAction = () => ({
  type: CheckNewOrders.CLEAR_CHECK_NEW_ORDERS_FAILED,
});
export function getCheckNewOrdersFailed(
  Date: string,
  callback?: (resp?: any) => void
) {
  return (dispatch: any) => {
    dispatch(checkNewOrdersFailedAction());
    HttpRequestPost(
      "/order/check-new/failed",
      dispatch,
      checkNewOrdersFailedSuccessAction,
      checkNewOrdersFailedFailureAction,
      true,
      { Date },
      callback
    );
  };
}

export function clearCheckNewOrdersFailed() {
  return (dispatch: any) => {
    dispatch(clearCheckNewOrdersAction());
  };
}
